import Swiper from 'swiper'

export default class PageNav {
  constructor(component) {
    this.dom = {
      $component: component,
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.initSlider()
  }

  initSlider() {
    const {dom} = this
    const swiper = new Swiper('.js-pageNavContainer', {
      slidesPerView: 'auto',
      spaceBetween: 18,
      breakpoints: {
        600: {
          allowTouchMove: false,
        },
      },
    })
  }

  unmount() {
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.PageNav = this
  }
}
